<template>
  <div class="container">
    <div class="header">
      <div class="w1250">
        <z-header></z-header>
      </div>
    </div>
    <div class="main w1200" v-if="pageInfo.hasOwnProperty('pageInfo')">
      <z-breadcrumb v-if="pageInfo.pageInfo.hasOwnProperty('breadcrumbs')" :options="pageInfo.pageInfo.breadcrumbs"></z-breadcrumb>
      <div class="state">
        <div class="title-l left-left">资质状态</div>
        <z-license-status :status="pageInfo.cards.base.status"></z-license-status>
        <span
          v-if="pageInfo.cards.base.reason"
          :style="{color: pageInfo.cards.base.status == 3 ? '#ce3b4f':'#A5ABC6', 'font-size': '12px'}"
          >&nbsp;{{ pageInfo.cards.base.reason }}</span
        >
        <template v-if="pageInfo.cards.base.bizId == 10">
          <i class="el-icon-warning icon-color-delete" />
          <span style="color: #ce3b4f; font-size: 12px"
            >该资质包对应资质行业有调整，不提供修改功能，且不允许关联新创意，请点击“添加资质”，重新上传资质备案</span
          >
        </template>
        <el-button v-if="pageInfo.cards.base.editFlag" type="primary" class="btn-120" @click="updateLicense">{{ buttonText }}</el-button>
        <div class="clearfix"></div>
      </div>
      <z-alert :tag-msg="pageInfo.pageInfo.tag_msg"></z-alert>
      <div v-if="pageInfo.hasOwnProperty('cards')">
        <el-card class="padd9" v-if="pageInfo.cards.hasOwnProperty('base')">
          <div class="cont-m">
            <h2>基本信息</h2>
            <div class="clearfix"></div>
            <table width="1140" border="0" cellspacing="0" cellpadding="0">
              <tr v-for="(data, key) in pageInfo.cards.base.data" :key="key">
                <td
                  width="74"
                  height="50"
                  align="left"
                  valign="top"
                  class="base-td-title"
                >
                  {{ data.label }}：
                </td>
                <td
                  width="1066"
                  align="left"
                  valign="top"
                  class="base-td-value"
                >
                  {{ data.value }}
                </td>
              </tr>
            </table>
          </div>
        </el-card>
        <div class="state inforg">
          <div class="title-l">我的资质信息</div>
        </div>
        <div
          class="detail-top"
          v-for="(item, key) in pageInfo.cards.license"
          :key="key"
        >
          <z-license-detail
            class="padd9"
            v-if="pageInfo.cards.hasOwnProperty('license')"
            :license-data="item"
          ></z-license-detail>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { getData } from "../utils/utils";
import LicenseDetail from "@/components/detail/LicenseDetail";
import qs from "qs";
export default {
  name: "Detail",
  components: {
    "z-license-detail": LicenseDetail,
  },
  data: function () {
    return {
      pageInfo: {},
      buttonText: "立即修改",
    };
  },
  computed: {
    isBrandZZFlag: function () {
      return window.location.host.includes("brand");
    },
    checkFlag: function () {
      return this.$route.query["checkFlag"];
    },
  },
  watch: {
    pageInfo: function (newData, oldData) {},
  },
  created: function () {
    let url = "/";
    let params = {};
    if (this.$route.query["customer_id"]) {
      params["customer_id"] = this.$route.query["customer_id"];
    }
    if (this.$route.query["clientId"]) {
      params["clientId"] = this.$route.query["clientId"];
    }
    if (this.$route.query["loginParam"]) {
      params["loginParam"] = this.$route.query["loginParam"];
    }
    url = url + Object.keys(params).length > 0 && `?${qs.stringify(params)}`;
    let packageId = this.$route.params.package_id || 0;
    if (packageId === 0 || isNaN(packageId)) {
      this.$router.push(url);
    } else {
      params["package_id"] = packageId;
      getData(
        this.isBrandZZFlag && this.checkFlag
          ? "/api/package/crm/pass/get"
          : this.isBrandZZFlag
          ? "/api/package/crm/inspect/get"
          : "/api/package/get",
        params,
        (res) => {
          if (res.code == 0) {
            this.pageInfo = res.data;
            if (this.pageInfo.cards.base.bizId === 10) {
              this.buttonText = "添加资质";
            }
            if (
              this.pageInfo.cards.base.status === 0 ||
              this.pageInfo.cards.base.status === null
            ) {
              this.$message.warning("访问的资质包状态异常");
              this.$router.push(url);
            }
          } else {
            this.$message.warning(res.msg);
            this.$router.push(url);
          }
        }
      );
    }
  },
  mounted: function () {},
  methods: {
    updateLicense: function () {
      let params = {};
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        params["clientId"] = this.$route.query["clientId"];
      }
      if (this.$route.query["loginParam"]) {
        params["loginParam"] = this.$route.query["loginParam"];
      }
      let packageId = this.$route.params.package_id || 0;
      if (this.pageInfo.cards.base.bizId !== 10) {
        params["packageId"] = packageId;
      }
      getData(
        this.isBrandZZFlag ? "/api/crm/subject/check" : "/api/subject/check",
        params,
        (res) => {
          if (res.code == 0) {
            if (packageId === 0 || isNaN(packageId)) {
              let url = "/";
              let urlHash = {};
              if (this.$route.query["customer_id"]) {
                urlHash["customer_id"] = this.$route.query["customer_id"];
              }
              if (this.$route.query["clientId"]) {
                urlHash["clientId"] = this.$route.query["clientId"];
              }
              if (this.$route.query["loginParam"]) {
                urlHash["loginParam"] = this.$route.query["loginParam"];
              }
              url =
                Object.keys(urlHash).length > 0
                  ? url + `?${qs.stringify(urlHash)}`
                  : url;
              this.$router.push(url);
            } else {
              let url = ""
              if(this.isBrandZZFlag && this.pageInfo.cards.base.status == 2){
                url = "/qulification/mature/license/update/" + packageId;
              } else{
                url = "/qulification/license/update/" + packageId;
              }
              let urlHash = {};
              if (this.$route.query["customer_id"]) {
                urlHash["customer_id"] = this.$route.query["customer_id"];
              }
              if (this.$route.query["clientId"]) {
                urlHash["clientId"] = this.$route.query["clientId"];
              }
              if (this.$route.query["loginParam"]) {
                urlHash["loginParam"] = this.$route.query["loginParam"];
              }
              url =
                Object.keys(urlHash).length > 0
                  ? url + `?${qs.stringify(urlHash)}`
                  : url;
              if (this.pageInfo.cards.base.bizId === 10) {
                this.jump();
              } else {
                this.$router.push(url);
              }
            }
          } else {
            this.$message.warning(res.msg);
            return false;
          }
        },
        (eres) => {},
        false
      );
    },
    jump: function () {
      let params = {};
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        params["clientId"] = this.$route.query["clientId"];
      }
      if (this.$route.query["loginParam"]) {
        params["loginParam"] = this.$route.query["loginParam"];
      }
      getData(
        this.isBrandZZFlag
          ? "/api/package/crm/getTemp"
          : "/api/package/getTemp",
        params,
        (res) => {
          if (res.code == 0) {
            if (res.data.packageId) {
              this.$confirm("您有一个未完成的资质证明，是否继续填写", "", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  center: true,
                  showClose: false,
                })
                .then(() => {
                  let url = "/qulification/license/" + res.data.packageId;
                  let urlHash = {};
                  if (this.$route.query["customer_id"]) {
                    urlHash["customer_id"] = this.$route.query["customer_id"];
                  }
                  if (this.$route.query["clientId"]) {
                    urlHash["clientId"] = this.$route.query["clientId"];
                  }
                  if (this.$route.query["loginParam"]) {
                    urlHash["loginParam"] = this.$route.query["loginParam"];
                  }
                  url =
                    Object.keys(urlHash).length > 0
                      ? url + `?${qs.stringify(urlHash)}`
                      : url;
                  this.$router.push(url);
                })
                .catch(() => {});
            } else {
              let url = "/qulification/base/";
              let urlHash = {};
              if (this.$route.query["customer_id"]) {
                urlHash["customer_id"] = this.$route.query["customer_id"];
              }
              if (this.$route.query["clientId"]) {
                urlHash["clientId"] = this.$route.query["clientId"];
              }
              if (this.$route.query["loginParam"]) {
                urlHash["loginParam"] = this.$route.query["loginParam"];
              }
              url =
                Object.keys(urlHash).length > 0
                  ? url + `?${qs.stringify(urlHash)}`
                  : url;
              this.$router.push(url);
            }
          } else {
            this.$message.warning(res.msg);
            return false;
          }
        },
        (eres) => {},
        false
      );
    },
  },
};
</script>
<style>
.panel-card {
  margin-top: 20px;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.left-left {
  float: left;
}

.state .title-l {
  font-size: 18px;
  color: #2e334a;
  margin-right: 10px;
  margin-bottom: 20px;
  font-weight: bold;
}

.state .btn-120 {
  width: 120px;
  height: 38px;
  float: right;
  margin-bottom: 10px;
  margin-top: -7px;
}

.cont-m {
  padding: 8px 13px;
  line-height: 28px;
}

.detail-padd9 {
  padding: 9px;
  color: #2e334a;
  margin-top: 10px;
}

.padd9 h2 {
  font-size: 18px;
  color: #2e334a;
  margin-bottom: 30px;
  float: left;
  margin-right: 5px;
}

.padd9 h2 i {
  font-size: 14px;
  font-style: normal;
  color: #8a93b6;
}

.padd9 table {
  font-size: 14px;
}

.padd9 dl {
  font-size: 14px;
}

.padd9 dd {
  padding-bottom: 30px;
}

.padd9 .w-checkbox_checkbox__2qnpS {
  margin-top: 2px;
}

.inforg {
  padding: 20px 0 0;
}

.borgaryg {
  border: 1px solid #cccccc;
}

.borredg {
  border: 1px solid #c83648;
}

.fontcolorredg {
  color: #c82439;
}

.detail-top {
  background: #fff;
  border: 1px solid #e1e6f1;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  padding: 21px;
  margin-bottom: 20px;
}

.base-td-title {
  min-width: 74px;
}

.base-td-value {
  max-width: 1066px;
  word-wrap: break-word;
  word-break: break-word;
}

.icon-color-delete {
  font-size: 14px;
  color: #c82439;
  border-radius: 1px;
  margin-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue